export const regex = {
  validateEmail:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  validatePassword: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{10,}$/,
  validatePhone: /^0\d{9,10}$/,
  validatePostCode: /^\d+$/,
  validateLink:
    /^(https:\/\/|http:\/\/)([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(:\d{1,5})?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/,
};
